/* You Will Rock — homepage (landing) behaviour.
   Carousels, hotspots, moment tabs, quick add, scratch-card popup.
   Loaded by every ywr-lp-* section; guarded so it runs once. */
(function () {
  if (window.__ywrLpLoaded) return;
  window.__ywrLpLoaded = true;

  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  var money = function (cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* ---------- toast ---------- */
  var toast = document.createElement('div');
  toast.className = 'lp-toast';
  toast.setAttribute('role', 'status');
  toast.hidden = true;
  var toastTimer;
  function showToast(html, ms) {
    toast.innerHTML = html;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, ms || 4200);
  }

  /* ---------- quick add ---------- */
  function bumpCart(count) {
    var cartLink = document.querySelector('.ywr .nav .cart');
    if (!cartLink) return;
    var n = cartLink.querySelector('.cartn');
    if (!n) { n = document.createElement('span'); n.className = 'cartn'; cartLink.appendChild(n); }
    n.textContent = count;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lp-add');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-id');
    if (!id) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Adding…';
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        bumpCart(cart.item_count);
        btn.innerHTML = 'Added ✓';
        showToast('<strong>' + (btn.getAttribute('data-title') || 'Added') + '</strong> is in your cart · <a href="' + root() + 'cart">View cart</a>');
        setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600);
      })
      .catch(function () {
        btn.innerHTML = label; btn.disabled = false;
        showToast('Could not add that just now. <a href="' + root() + 'cart">Open the cart</a> and try again.');
      });
  });

  /* ---------- carousels ----------
     Touch keeps native momentum + CSS snap (best feel, gated to coarse pointers in the CSS).
     Mouse, wheel and arrows are driven here so every settle uses one easing curve: drag with
     pointer capture, throw with velocity, then glide to the nearest card. No CSS snap is active
     on fine pointers, so nothing fights the animation mid-gesture. */
  var REDUCE = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function setupCarousel(car) {
    var track = car.querySelector('.lp-track');
    if (!track) return;
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    var raf = 0, tick = 0, stops = [], maxScroll = 0, goal = null;

    function cancelGlide() { if (raf) { cancelAnimationFrame(raf); raf = 0; } goal = null; }
    function clamp(x) { return Math.max(0, Math.min(maxScroll, x)); }

    /* scrollLeft values that align each card with the content edge */
    function measure() {
      maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      /* scroll coordinate of the content start: a card's stop is its left edge relative to this */
      var base = track.getBoundingClientRect().left + padL - track.scrollLeft;
      stops = [];
      for (var i = 0; i < track.children.length; i++) {
        var el = track.children[i];
        if (el.hidden || !el.offsetParent) continue;
        var s = clamp(Math.round(el.getBoundingClientRect().left - base));
        if (!stops.length || Math.abs(s - stops[stops.length - 1]) > 2) stops.push(s);
      }
      if (!stops.length) stops = [0];
      if (stops[stops.length - 1] < maxScroll - 2) stops.push(maxScroll);
    }
    function nearest(pos) {
      var best = stops[0], d = Infinity;
      for (var i = 0; i < stops.length; i++) {
        var dd = Math.abs(stops[i] - pos);
        if (dd < d) { d = dd; best = stops[i]; }
      }
      return best;
    }
    function step(dir) {
      var here = goal == null ? track.scrollLeft : goal;
      if (dir > 0) {
        for (var i = 0; i < stops.length; i++) if (stops[i] > here + 4) return stops[i];
        return maxScroll;
      }
      for (var j = stops.length - 1; j >= 0; j--) if (stops[j] < here - 4) return stops[j];
      return 0;
    }
    function update() {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = 0;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      });
    }

    /* one easing curve for every programmatic move */
    function glide(to, dur) {
      cancelGlide();
      to = clamp(to);
      var from = track.scrollLeft, dist = to - from;
      if (Math.abs(dist) < 1) { update(); return; }
      if (REDUCE.matches) { track.scrollLeft = to; update(); return; }
      goal = to;
      var t0 = performance.now();
      raf = requestAnimationFrame(function frame(now) {
        var t = Math.min(1, (now - t0) / dur);
        var e = t === 1 ? 1 : 1 - Math.pow(2, -9 * t);
        track.scrollLeft = from + dist * e;
        update();
        if (t < 1) { raf = requestAnimationFrame(frame); } else { raf = 0; goal = null; }
      });
    }

    /* ---- drag / throw (mouse + pen; touch scrolls natively) ---- */
    var dragging = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0, moved = 0, pid = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || e.button !== 0) return;
      if (e.target.closest('button, a, input, [data-pop-close]')) { moved = 0; }
      cancelGlide();
      measure();
      dragging = true; moved = 0; pid = e.pointerId;
      startX = lastX = e.clientX; startLeft = track.scrollLeft;
      lastT = performance.now(); vel = 0;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(pid); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pid) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      track.scrollLeft = startLeft - dx;
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) vel = 0.75 * ((e.clientX - lastX) / dt) + 0.25 * vel; /* px per ms, smoothed */
      lastX = e.clientX; lastT = now;
      update();
      e.preventDefault();
    });

    function endDrag(e) {
      if (!dragging || (e.pointerId != null && e.pointerId !== pid)) return;
      dragging = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(pid); } catch (err) {}
      pid = null;
      if (performance.now() - lastT > 90) vel = 0; /* paused before releasing: no throw */
      var throwDist = vel * 170;
      var target = nearest(track.scrollLeft - throwDist);
      glide(target, Math.abs(vel) > 0.4 ? 700 : 520);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    /* a drag must never fire the click underneath it */
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);

    /* ---- trackpad: free scroll, then settle once the gesture stops ---- */
    var wheelTimer;
    track.addEventListener('wheel', function () {
      cancelGlide();
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(function () {
        if (dragging) return;
        measure();
        glide(nearest(track.scrollLeft), 420);
      }, 130);
    }, { passive: true });

    /* ---- arrows + keyboard ---- */
    if (prev) prev.addEventListener('click', function () { measure(); glide(step(-1), 560); });
    if (next) next.addEventListener('click', function () { measure(); glide(step(1), 560); });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      measure();
      glide(step(e.key === 'ArrowRight' ? 1 : -1), 560);
      e.preventDefault();
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { cancelGlide(); measure(); update(); });
    if (window.ResizeObserver) new ResizeObserver(function () { measure(); update(); }).observe(track);

    measure(); update();
    car.__update = function () { measure(); update(); };
  }
  document.querySelectorAll('.lp-carousel').forEach(setupCarousel);

  /* ---------- hotspots (desktop) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.lp-hs-btn');
    if (!b) {
      if (!e.target.closest('.lp-hs')) document.querySelectorAll('.lp-hs.is-open').forEach(function (h) { h.classList.remove('is-open'); h.querySelector('.lp-hs-btn').setAttribute('aria-expanded', 'false'); });
      return;
    }
    var hs = b.closest('.lp-hs');
    var open = hs.classList.contains('is-open');
    document.querySelectorAll('.lp-hs.is-open').forEach(function (h) { h.classList.remove('is-open'); h.querySelector('.lp-hs-btn').setAttribute('aria-expanded', 'false'); });
    if (!open) { hs.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
  });

  /* ---------- moment tabs ---------- */
  document.querySelectorAll('.lp-tabs').forEach(function (tabs) {
    var car = tabs.closest('section').querySelector('.lp-carousel');
    var track = car && car.querySelector('.lp-track');
    tabs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-group]');
      if (!t) return;
      tabs.querySelectorAll('[data-group]').forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      var g = t.getAttribute('data-group');
      if (track) {
        track.querySelectorAll('[data-group]').forEach(function (c) { c.hidden = g !== 'all' && c.getAttribute('data-group') !== g; });
        track.scrollTo({ left: 0 });
        if (car.__update) car.__update();
      }
    });
  });

  /* ---------- scratch-card popup ---------- */
  var pop = document.querySelector('.lp-pop');
  if (pop) {
    var key = 'ywr-lp-pop';
    var days = Number(pop.getAttribute('data-days') || 7);
    var delay = Number(pop.getAttribute('data-delay') || 8) * 1000;
    var seen = 0;
    try { seen = Number(localStorage.getItem(key) || 0); } catch (e) {}
    var fresh = seen && (Date.now() - seen) < days * 864e5;
    function remember() { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    function close() { pop.hidden = true; document.documentElement.classList.remove('lp-pop-open'); remember(); }
    pop.querySelectorAll('[data-pop-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', remember);

    function initScratch() {
      var canvas = pop.querySelector('canvas');
      if (!canvas) return;
      var card = canvas.parentElement;
      var w = card.clientWidth, h = card.clientHeight;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#CFE3F4'); g.addColorStop(.5, '#9CC3E6'); g.addColorStop(1, '#CFE3F4');
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(14,32,56,.75)';
      ctx.font = '800 22px "Bricolage Grotesque", sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText(canvas.getAttribute('data-label') || 'SCRATCH HERE', w / 2, h / 2 + 8);
      ctx.globalCompositeOperation = 'destination-out';
      var scratching = false, cleared = false;
      function at(e) {
        var r = canvas.getBoundingClientRect();
        var p = e.touches ? e.touches[0] : e;
        return { x: p.clientX - r.left, y: p.clientY - r.top };
      }
      function scrub(e) {
        if (!scratching || cleared) return;
        var p = at(e);
        ctx.beginPath(); ctx.arc(p.x, p.y, 26, 0, Math.PI * 2); ctx.fill();
        e.preventDefault();
        if (Math.random() < .15) check();
      }
      function check() {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0, total = data.length / 4;
        for (var i = 3; i < data.length; i += 4 * 9) if (data[i] === 0) clear++;
        if (clear / (total / 9) > .45) {
          cleared = true;
          canvas.style.transition = 'opacity .5s';
          canvas.style.opacity = '0';
          pop.classList.add('is-revealed');
          var em = pop.querySelector('input[type=email]');
          if (em) setTimeout(function () { em.focus(); }, 600);
        }
      }
      ['mousedown', 'touchstart'].forEach(function (ev) { canvas.addEventListener(ev, function (e) { scratching = true; scrub(e); }, { passive: false }); });
      ['mousemove', 'touchmove'].forEach(function (ev) { canvas.addEventListener(ev, scrub, { passive: false }); });
      ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (ev) { canvas.addEventListener(ev, function () { scratching = false; check(); }); });
      var skip = pop.querySelector('[data-pop-skip]');
      if (skip) skip.addEventListener('click', function () { cleared = true; canvas.style.opacity = '0'; pop.classList.add('is-revealed'); });
    }

    if (pop.getAttribute('data-force') === 'true') {
      /* form just posted (thanks or error state): show it straight away */
      pop.hidden = false;
      document.documentElement.classList.add('lp-pop-open');
      pop.classList.add('is-revealed');
      var cv = pop.querySelector('canvas');
      if (cv) cv.style.opacity = '0';
    } else if (!fresh && pop.getAttribute('data-enabled') === 'true' && !/(^|[?&])lp_pop=0/.test(location.search)) {
      setTimeout(function () {
        pop.hidden = false;
        document.documentElement.classList.add('lp-pop-open');
        requestAnimationFrame(initScratch);
      }, delay);
    }
  }

  document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(toast); });
  if (document.readyState !== 'loading') document.body.appendChild(toast);
})();
